/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormGroup } from "react-bootstrap-3";
import FieldErrorList from "./FieldErrorList";
import InputGroup from "./InputGroup";

function SelectGroup({ errors, value, hasErrors, onChange, field, additionalFields, className }) {
  const { fieldName, optionDisplay, disabled, defaultValue } = field;
  return (
    <div className={`SelectGroup ${field.className} ${className}`}>
      <FormGroup>
        <FormControl
          defaultValue={defaultValue}
          disabled={disabled}
          value={value}
          name={fieldName}
          componentClass="select"
          className={`form-control ${hasErrors && "parsley-error"}`}
          onChange={event => onChange({ event, field: fieldName })}>
          {Object.keys(optionDisplay).map(key => (
            <option value={key} key={key}>
              {optionDisplay[key].label}
            </option>
          ))}
        </FormControl>
        {additionalFields &&
        additionalFields.map(additionalField => {
          if (additionalField.isVisible) {
            // Created a switch for a future implementations,
            // additionalField could be select, checkbox...
            switch (additionalField.type) {
              default:
                return (
                  <>
                    <InputGroup
                      disabled={disabled}
                      value={additionalField.value}
                      field={additionalField.field}
                      onChange={additionalField.onChange}
                    />
                    {additionalField.errors && <FieldErrorList errors={additionalField.errors} />}
                  </>
                );
            }
          } else {
            return null;
          }
        })}
      </FormGroup>
    </div>
  );
}

SelectGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SelectGroup;
